import { type ReactNode } from 'react';
import { cn } from './cn';

export interface InlineExpandRowProps {
  list?: ReactNode;
  input?: ReactNode;
  preview?: ReactNode;
  className?: string;
}

export const InlineExpandRow = ({ list, input, preview, className }: InlineExpandRowProps) => (
  <div
    className={cn('grid gap-4 p-4', className)}
    style={{
      gridTemplateColumns: list && input && preview ? '1fr 1fr 1fr' : '1fr',
    }}
  >
    {list ? (
      <div className="flex flex-col gap-2">{list}</div>
    ) : null}
    {input ? (
      <div className="flex flex-col gap-2">{input}</div>
    ) : null}
    {preview ? (
      <div className="flex flex-col gap-2">{preview}</div>
    ) : null}
  </div>
);
